import React from 'react';

// https://codepen.io/web-tiki/pen/qEGvMN - radial progress bar
export default function UI5LoadingCircle(props) {

    const viewScale = 1;
    const width = 100 * viewScale;
    const padding = width/10;
    const strokeWidth = padding * 2;
    const circleCenter = width/2;
    const radius = width/2 - padding;

    const move = (x, y) => "M{0} {1}".f(x,y)
    const arc = (rx, ry, dx, dy) => "a {0} {1} 0 0 1 {2} {3}".f(rx,ry,dx,dy)

    const viewBox = "0 0 {0} {1}".f(width, width);
    const path = [
        move(radius + padding, padding),
        arc(radius,radius,0,2 * radius),
        arc(radius,radius,0,-2 * radius)
    ].join(' ');

    const dashGapLength = 250;
    const value = props.value * dashGapLength/100;

    const style = {}
    if (props.size) {
        style.width = props.size+"px"
        style.height = props.size+"px"
    }

    return (
        <div className={Classes("ui5-loading-circle", props.className)} style={style}>
            <svg className="ui5-loading-circle-container" viewBox={viewBox}>
                <circle className="circle" cx={circleCenter} cy={circleCenter} r={radius} strokeWidth={strokeWidth}/>
                <path className="path" d={path} strokeWidth={strokeWidth} strokeDasharray={'{0},{1}'.f(value,dashGapLength)}/>
            </svg>
        </div>
    );
}